export const WELCOME_BACK_MESSAGES = [
  "Welcome back. Showing up again is what matters.",
  "You're here — that's the hardest part.",
  "Breaks happen. What counts is coming back.",
  "Good to see you. Ready to pick up where you left off?",
  "You showed up. Let's get back to it.",
  "The streak reset, but the habit knowledge didn't.",
  "Every restart is still a step forward.",
  "You came back. That says more than any streak number.",
] as const;

export const SCORE_EXPLANATION =
  "Your scores adjusted while you were away — that's normal. They'll recover as you get back into it.";

export const RETURN_CTA = "Pick one habit to restart with today";

export function getRandomWelcomeBack(): string {
  const idx = Math.floor(Math.random() * WELCOME_BACK_MESSAGES.length);
  return WELCOME_BACK_MESSAGES[idx];
}
